import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { Col, Row } from "antd";

import { useLayoutEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import BotonSubmit from "../../../../components/Boton/BotonSubmit";

import { MAPBOX_TOKEN } from "../../../../constants/cons";

import geoFetch from "../../../../utils/geoFetch";
import { DireccionOrigen } from "./DireccionOrigen";
import { fnDivideFeature } from "./fnDivideFeature";
import { InputLatLng } from "./InputLatLng";
import { InputTextSerach } from "./InputTextSerach";
import { LatLng } from "./LatLng";
import { Sitios } from "./Sitios";

mapboxgl.accessToken = MAPBOX_TOKEN;

export const Mapa = ({ onChange, lat, lng, direccionFull }) => {
  console.log(lat, lng);

  const history = useHistory();
  const { asistenciaID } = useParams();
  const dispatch = useDispatch();
  const map = useRef(null);
  const mapContainer = useRef(null);
  const marker = useRef(null);

  const [textoLatLng, setTextoLatLng] = useState("");
  const [textoBusca, setTextoBusca] = useState("");

  const [sitios, setSitios] = useState([]);
  const [longitud, setLongitud] = useState(lng);
  const [latitud, setLatitud] = useState(lat);
  const [zoom, setZoom] = useState(14);
  const [direccion, setDireccion] = useState({
    direccionOrigen: direccionFull,
  });
  //
  const debounedref = useRef(null);

  /// INICIAL
  //////////////////////////////////////////////
  useLayoutEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      controls: true,
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [longitud, latitud],
      zoom: zoom,
    });

    map.current.addControl(new mapboxgl.NavigationControl());
    marker.current = new mapboxgl.Marker({
      draggable: true,
    })
      .setLngLat([longitud, latitud])
      .addTo(map.current);

    marker.current.on("dragend", onDragEnd);
    map.current.on("move", () => {
      setZoom(map.current.getZoom().toFixed(2));
    });
  }, [longitud]);

  /// para el drag and drop
  //////////////////////////////////////////////
  async function onDragEnd() {
    setTextoLatLng("");
    setTextoBusca("");
    const { lng, lat } = await marker.current.getLngLat();
    setLatitud(lat);
    setLongitud(lng);
    getAddressByPin(lng, lat);
    setSitios([]);
  }

  /// cuando hacen busqueda texto
  //////////////////////////////////////////////
  const handleSearch = ({ target }) => {
    setTextoBusca(target.value);
    if (debounedref.current) clearTimeout(debounedref.current);
    debounedref.current = setTimeout(async () => {
      try {
        const { data } = await geoFetch(`${target.value}.json`, {
          params: { proximity: [longitud, latitud] },
        });
        setSitios(data.features);
      } catch (e) {
        console.log(e);
      }
    }, 1500);
  };

  /// Sacamos la direccion desde un PIN
  //////////////////////////////////////////////
  const getAddressByPin = async (lng, lat) => {
    try {
      const { data } = await geoFetch(`${lng},${lat}.json`, {
        params: { limit: 1 },
      });
      const latLng = {
        latOrigen: lat.toString(),
        lngOrigen: lng.toString(),
      };

      const salida = { ...fnDivideFeature(data.features[0]), ...latLng };
      setBody(salida);
    } catch (e) {
      console.log(e);
    }
  };

  /// cuando ponen lat y lng directo
  //////////////////////////////////////////////
  const handleLatLng = ({ target }) => {
    setTextoLatLng(target.value);
    setTextoBusca("");

    if (target.value !== "") {
      const arr = target.value.split(",");
      if (arr.length === 2) {
        const newLatitud = Number(arr[0]);
        const newlongitud = Number(arr[1]);
        setLatitud(newLatitud);
        setLongitud(newlongitud);
        getAddressByPin(newlongitud, newLatitud);
        map.current.flyTo({
          center: [newlongitud, newLatitud],
          essential: true, // this animation is considered essential with respect to prefers-reduced-motion
        });

        marker.current.setLngLat([newlongitud, newLatitud]);
      }
    }
  };

  /// En la busqueda el click
  //////////////////////////////////////////////
  const handleSitioClick = (sitio) => {
    setTextoLatLng("");
    map.current.flyTo({
      center: sitio.center,
      essential: true, // this animation is considered essential with respect to prefers-reduced-motion
    });

    marker.current.setLngLat(sitio.center);
    setLatitud(sitio.center[1]);
    setLongitud(sitio.center[0]);
    setSitios([]);
    const latLng = {
      latOrigen: sitio.center[1].toString(),
      lngOrigen: sitio.center[0].toString(),
    };
    const salida = { ...fnDivideFeature(sitio), ...latLng };

    setBody(salida);
  };

  const setBody = (salida) => {
    setDireccion(salida);
  };

  // dice origen, pero es para destino, se reusó el codigo
  const handleGuardar = () => {
    const salida = {
      asistenciaID,
      cp: direccion.cpOrigen,
      direccion: direccion.direccionOrigen,
      estado: direccion.estadoOrigen,
      lat: direccion.latOrigen,
      lng: direccion.lngOrigen,
      municipio: direccion.municipioOrigen,
    };
    onChange(salida);
    //dispatch(startPostDestino(salida));
    //history.push(`/detalleAsistencia/${asistenciaID}`);
  };
  //////////////////////////////////////////////
  return (
    <>
      <div ref={mapContainer} style={styles.mapContainer}>
        <div style={styles.dataContainer}>
          <Row gutter={[10, 10]} style={{ marginTop: 10 }}>
            <InputTextSerach
              textoBusca={textoBusca}
              handleSearch={handleSearch}
            />
            <InputLatLng
              handleLatLng={handleLatLng}
              textoLatLng={textoLatLng}
            />
            <LatLng latitud={latitud} longitud={longitud} zoom={zoom} />

            <DireccionOrigen direccionOrigen={direccion.direccionOrigen} />
          </Row>
          <Sitios sitios={sitios} handleSitioClick={handleSitioClick} />
        </div>
      </div>

      <BotonSubmit tituloBoton="Guardar Dirección" onClick={handleGuardar} />
    </>
  );
};

const styles = {
  dataContainer: {
    zIndex: 9999,
    position: "relative",
    width: "90%",
    paddingLeft: 10,
  },
  mapContainer: {
    height: 470,
    width: "100%",
    marginBottom: 10,
  },
};
